import React, { useState } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import { makeStyles } from "@material-ui/core/styles";
import Avatar from "../../../../../../../../ui/Avatar";
import SymbolIcon from "../../../../../../../../ui/SymbolIcon";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import MoreVertIcon from '@material-ui/icons/MoreVert';
import PersonOutlineOutlinedIcon from "@material-ui/icons/PersonOutlineOutlined";
import DeleteConfirmationModal from "../DeleteConfirmationModal";
import useManageEmployees from "../../../../../../../hooks/useManageEmployees";
import ManageEmployee from "../ManageEmployee";

const useStyles = makeStyles(() => ({
    root: {
        width: 240,
        height: 190,
        padding: 10,
        background: "#FFFFFF",
        border: "1px solid #CACCD1",
        boxSizing: "border-box",
        boxShadow: "3px 3px 5px rgba(0, 0, 0, 0.1)",
        position: "relative"
    },
    line: {
        height: "1px",
        background: "#CACCD1",
        position: "absolute",
        left: "0%",
        right: "0%",
        top: "27.89%",
        bottom: "72.11%"
    },
    profileInfo: {
        display: "flex",
        alignItems: "center",
        flexDirection: "column"
    },
    avatarContainer: {
        width: 80,
        height: 80,
        border: "1px solid #CACCD1",
        boxSizing: "border-box",
        borderRadius: "75px",
        background: "#FFFFFF",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1
    },
    name: {
        marginTop: 10,
        fontSize: "14px",
        textAlign: "center",
        color: "#000000"
    },
    post: {
        marginTop: 7,
        fontSize: "10px",
        textAlign: "center",
        textTransform: "uppercase",
        color: "#596E79"
    },
    moreIcon: props => ({
        position: "absolute",
        left: "88.33%",
        right: "4.17%",
        top: "7%",
        cursor: "pointer",
        color: props.isOpened ? "#FFFFFF" : "#C4C4C4",
        zIndex: 100
    }),
    docPopover: props => ({
        display: props.isOpened ? "block" : "none",
        position: "absolute",
        left: "40%",
        right: "0%",
        top: "0%",
        bottom: "0%",
        background: "rgba(89, 110, 121, 0.8)",
        paddingTop: 45,
        zIndex: 1
    }),
    popoverItem: {
        background: "rgba(255, 255, 255, 0)",
        color: "#FFFFFF",
        height: 32,
        padding: "8px 16px",
        cursor: "pointer",
        "&:hover": {
            background: "rgba(255, 255, 255, 0.2)"
        }
    },
    iconsContainer: {
        bottom: "0",
        left: "0",
        padding: 10,
        display: "flex",
        position: "absolute",
        width: "100%",
        justifyContent: "space-between"
    },
    iconsItem: {
        display: "flex",
        flexDirection: "row"
    }
}));

export const transformNameInfoInitials = name => {
    const [lastName, firstName, middleName] = name ? name.split(" ") : "";

    return `${lastName} ${firstName ? firstName[0] + "." : ""}${
        middleName ? middleName[0] + "." : ""
    }`;
};

const EmployeeCard = ({ data, orgId, update }) => {
    const { deleteEmployee, blockEmployee, updateEmployee } = useManageEmployees(update);
    const [isOpened, open] = useState(false);
    const [isDeleteEmployeeOpened, openDeleteEmployee] = useState(false);
    const [isBlockEmployeeOpen, openBlockEmployee] = useState(false);
    const [isManageEmployeeOpen, openManageEmployee] = useState(false);
    const classes = useStyles({ isOpened });

    return (
        <div className={classes.root}>
            <span className={classes.line}></span>
            {isOpened
              ? <MoreVertIcon
                  className={classes.moreIcon}
                  onClick={() => open(!isOpened)}/>
              : <MoreHorizIcon
                className={classes.moreIcon}
                onClick={() => open(!isOpened)}/>
              }
            <DeleteConfirmationModal
                open={isDeleteEmployeeOpened}
                handleClose={() => openDeleteEmployee(false)}
                onConfirm={() => deleteEmployee(orgId, data.id)}
                actionName="Удалить"
                employee={data}
            />
            <DeleteConfirmationModal
                open={isBlockEmployeeOpen}
                handleClose={() => openBlockEmployee(false)}
                updateEmployee={() => blockEmployee(data.personId)}
                actionName="Заблокировать"
                employee={data}
            />
            <ManageEmployee
                open={isManageEmployeeOpen}
                handleClose={() => openManageEmployee(false)}
                updateEmployee={updateEmployee}
                employee={data}
                orgId={orgId}
            />
            <div className={classes.profileInfo}>
                {data.avatar ? (
                    <Avatar
                        imageId={data.avatar}
                        className={classes.avatarContainer}
                    />
                ) : (
                    <div className={classes.avatarContainer}>
                        <PersonOutlineOutlinedIcon
                            style={{ color: "#CACCD1" }}
                        />
                    </div>
                )}
                <div className={classes.name}>
                    {transformNameInfoInitials(data.name)}
                </div>
                <div className={classes.post}>{data.postName}</div>
                <div className={classes.iconsContainer}>
                    <div className={classes.iconsItem}>
                        {data.roles.map((role, idx) => (
                            <SymbolIcon key={`role_${idx}`} text={role.symbol} />
                        ))}
                    </div>
                    <div className={classes.iconsItem}></div>
                </div>
            </div>
            <OutsideClickHandler onOutsideClick={() => open(false)}>
                <div className={classes.docPopover}>
                    <div
                        className={classes.popoverItem}
                        onClick={() => {
                            open(false);
                            openDeleteEmployee(true);
                        }}
                    >
                        Удалить
                    </div>
                    <div
                        className={classes.popoverItem}
                        onClick={() => {
                            open(false);
                            openBlockEmployee(true);
                        }}
                    >
                        Заблокировать
                    </div>
                    <div
                        className={classes.popoverItem}
                        onClick={() => {
                            open(false);
                            openManageEmployee(true);
                        }}
                    >
                        Изменить
                    </div>
                </div>
            </OutsideClickHandler>
        </div>
    );
};

export default EmployeeCard;
